const CARDS = [
  {
    key: "revenue",
    label: "Total Revenue",
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    iconBg: "bg-blue-50 text-blue-600",
    bar: "bg-blue-500",
  },
  {
    key: "collected",
    label: "Amount Collected",
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    iconBg: "bg-emerald-50 text-emerald-600",
    bar: "bg-emerald-500",
  },
  {
    key: "orders",
    label: "Total Orders",
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
      </svg>
    ),
    iconBg: "bg-orange-50 text-orange-600",
    bar: "bg-orange-500",
  },
  {
    key: "aov",
    label: "Avg Order Value",
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    iconBg: "bg-violet-50 text-violet-600",
    bar: "bg-violet-500",
  },
];

const SummaryCards = ({ summary }) => {
  const { total_revenue, amount_collected, amount_pending, total_orders, avg_orders_per_day, avg_order_value } = summary;

  const values = [
    { primary: total_revenue, sub: `${total_orders} orders` },
    { primary: amount_collected, sub: `${amount_pending} pending` },
    { primary: total_orders, sub: `${avg_orders_per_day} avg/day` },
    { primary: avg_order_value, sub: "per order" },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {CARDS.map((c, i) => (
        <div key={c.key} className="bg-white rounded-xl border border-gray-100 shadow-sm p-3.5">
          <div className="flex items-center justify-between mb-2.5">
            <span className="text-xs font-medium text-gray-500">{c.label}</span>
            <span className={`p-1.5 rounded-lg ${c.iconBg}`}>{c.icon}</span>
          </div>
          <p className="text-lg font-bold text-gray-800 leading-tight">{values[i].primary}</p>
          <p className="text-xs text-gray-400 mt-1">{values[i].sub}</p>
          <div className={`mt-2.5 h-0.5 rounded-full opacity-30 ${c.bar}`} />
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
